import { unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../internal/dds-hu-element'
import styles from './table-row.scss?inline'

/**
 * Table row component.
 * @element dap-ds-table-row
 * @title - Table row
 * @group table
 *
 * @slot - The default slot. Accepts `dap-ds-table-cell` and `dap-ds-table-header` elements.
 *
 * @cssprop --dds-table-row-padding-right - Padding right for the last table header, defaults to var(--dds-spacing-500)
 * @cssprop --dds-table-row-padding-top - Padding top for table headers in mobile view, defaults to var(--dds-spacing-400)
 * @cssprop --dds-table-row-padding-bottom - Padding bottom for the last table cell in mobile view, defaults to var(--dds-spacing-400)
 * @cssprop --dds-table-row-border-color - Border color for table cells and headers, defaults to transparent
 */
@customElement('dap-ds-table-row')
export default class DapDSTableRow extends DdsElement {
  static readonly styles = unsafeCSS(styles)

  /** The html role of the row */
  @property({ reflect: true })
  public role = 'row'

  /**If the row is mobile design */
  @property({ type: Boolean, reflect: true }) mobile = false

  render() {
    return html` <slot></slot> `
  }
}
